import React from 'react'
import { getDateFormat } from '../../Config/functions'

export const BookingHistory = ({data}:any) => {

    return (
        <div className="col-sm-12 card p-5 mt-5">
            <div className="row">
                <div className="col-sm-12 px-4">
                    <h4>Payment History</h4>
                
                    {data!=null && data.length >0 ?
                   
                   data.map((el:any) =>
                     (
                    <table className="table table-striped border-0 mt-4">
                        <tbody>
                            <tr>
                                <th scope="row">Payment Date:</th>
                                <td>{el.booking_date  !== "" ?getDateFormat(el.booking_date) : ""}</td>
                                <th scope="row">Payment Time:</th>
                                <td>{el.booking_time}</td>
                                <th scope="row">Booking Amount:</th>
                                <td>{el.booking_amount}</td>
                                <th scope="row">Subscription Amount:</th>
                                <td>{el.subscription_amount}</td>
                                <th scope="row"> Booking Expert:</th>
                                <td>{el.booking_expert}</td>
                            </tr>
                        </tbody>
                    </table>)) : "No Payment History Available "}
                    
                </div>
            </div>

        </div>
    )
}
